"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _activityCreationApi = require("@/api/activityCreationApi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CustomOfficialEvents',
  props: {
    selectCategory: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      PlatformData: [{
        name: '全部',
        id: ''
      }, {
        name: '淘宝',
        id: 'TB'
      }, {
        name: '京东',
        id: 'JD'
      }, {
        name: '拼多多',
        id: 'PDD'
      }, {
        name: '抖音',
        id: 'DY'
      }, {
        name: '唯品会',
        id: 'WPH'
      }],
      queryData: {
        name: '',
        status: '',
        unionCode: '',
        page: {
          page: 1,
          size: 10
        }
      },
      pagination: {
        // currentPage: 1, // 默认第几页
        total: 0 // 条数
      },
      tableData: []
    };
  },
  created: function created() {
    this.listActivityApi();
  },
  methods: {
    onPlatform: function onPlatform(value) {
      this.queryData.unionCode = value.id;
      this.onInquire();
    },
    // 查询
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.listActivityApi();
    },
    // 初始化
    onInit: function onInit() {
      this.queryData = {
        name: '',
        status: '',
        unionCode: '',
        page: {
          page: 1,
          size: 10
        }
      };
    },
    // 重置
    onInitialize: function onInitialize() {
      this.onInit();
      this.listActivityApi();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.listActivityApi();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.listActivityApi();
    },
    // 选择
    onSelectEvents: function onSelectEvents(value) {
      var data = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, value), {}, {
        Display_type: this.selectCategory,
        // 区分类型
        Display_name: '官方活动' // 名字
      });
      this.$emit('SelectEvents', data);
      this.onInit();
    },
    // 列表
    listActivityApi: function () {
      var _listActivityApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              this.tableLoading = true;
              params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.queryData), {}, {
                jumpType: this.selectCategory
              });
              _context.n = 1;
              return (0, _activityCreationApi.listActivityApi)(params);
            case 1:
              res = _context.v;
              this.tableLoading = false;
              if (res.code === 0) {
                this.tableData = res.data.records;
                this.pagination.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function listActivityApi() {
        return _listActivityApi2.apply(this, arguments);
      }
      return listActivityApi;
    }()
  }
};